/*发票 */
import { $http, buildHeaders } from "./index";

//获取列表
export const invoice_page = (params) => {
  return $http.get("/admin/Invoice/index", {
    params,
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//获取详情
export const invoice_detail = (id) => {
  return $http.get("/admin/Invoice/read?id=" + id, {
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//获取详情
export const invoice_search = (id) => {
  return $http.get("/admin/Invoice/detail?id=" + id, {
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//导出
export const invoice_export = (params) => {
  return $http.get("admin/Invoice/export", {
    params,
    responseType: "blob",
    headers: buildHeaders(1, "正在下载文件，请稍后……"),
  });
};

//确认开票
export const invoice_do = (data) => {
  return $http.post("/admin/Invoice/do", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//确认到款
export const invoice_receipt = (data) => {
  return $http.post("/admin/Invoice/receipt", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//作废
export const invoice_invalid = (data) => {
  return $http.post("/admin/Invoice/invalid", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//红冲
export const invoice_reverse = (data) => {
  return $http.post("/admin/Invoice/reverse", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};
